import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import classnames from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import {
    onChangeMapFilters,
    onChangeRebalanceMinGapDownEnabled,
    onChangeRebalanceMinGapUpEnabled,
    onChangeRebalanceOnlyEmptyEnabled,
} from '../../../ac/onChangeMapFilters';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import {
    REBALANCE_FORECAST_LEGEND,
    REBALANCE_FORECAST_SIZE_LEGEND,
    REBALANCE_DELTA_LEGEND,
    REBALANCE_DELTA_SIZE_LEGEND,
} from '../../../constants/legends';
import { StandardRadioGroup } from '../StandardRadioGroup';
import styles from '../FilterSidebar.module.css';

const RebalanceForecastTabaLegendComponent = ({
    onChangeMapFilters,
    onChangeRebalanceMinGapUpEnabled,
    onChangeRebalanceMinGapDownEnabled,
    onChangeRebalanceOnlyEmptyEnabled,
    rebalanceForecastTabaMode,
    rebalanceMinGapUpEnabled,
    rebalanceMinGapDownEnabled,
    rebalanceOnlyEmptyEnabled,
}) => {
    const MODES = [
        { value: 'taba', label: t`Таба` },
        { value: 'forecast', label: t`Форкаст` },
    ];
    const handleModeChange = ({ target: { value } }) => {
        onChangeMapFilters('rebalanceForecastTabaMode', value);
    };
    const isForecast = rebalanceForecastTabaMode === 'forecast';
    // Раздельные пороги ребаланса из настроек региона: избыток (вывоз) и дефицит (привоз)
    const MIN_GAP_TOGGLES = [
        {
            id: 'rebalanceMinGapUp',
            label: t`Мин. отклонение: избыток`,
            checked: rebalanceMinGapUpEnabled,
            onChange: onChangeRebalanceMinGapUpEnabled,
        },
        {
            id: 'rebalanceMinGapDown',
            label: t`Мин. отклонение: дефицит`,
            checked: rebalanceMinGapDownEnabled,
            onChange: onChangeRebalanceMinGapDownEnabled,
        },
    ];
    return (
        <div>
            <StandardRadioGroup
                value={String(rebalanceForecastTabaMode)}
                onChange={handleModeChange}
            >
                {MODES.map(({ value, label }) => (
                    <FormControlLabel
                        key={value}
                        className={styles.isochroneFilterLabel}
                        control={
                            <Radio
                                checked={rebalanceForecastTabaMode === value}
                                onChange={handleModeChange}
                                value={value}
                                className={classnames(
                                    styles.isochroneFilterInput, {
                                        [styles.checkedIsochroneFilterInput]: rebalanceForecastTabaMode === value,
                                    }
                                )}
                                size="small"
                            />
                        }
                        label={label}
                    />
                ))}
            </StandardRadioGroup>
            {/* Тоггл «только парковки без самокатов» — только в режиме «Таба» */}
            {!isForecast && (
                <div style={{ paddingLeft: '0px', display: 'flex', flexDirection: 'column', gap: '2px', marginBottom: '10px' }}>
                    <div className={styles.isochroneFilterLabel}>
                        <span style={{ width: '26px', flexShrink: 0 }} />
                        <label
                            htmlFor='rebalanceOnlyEmpty'
                            style={{ flex: 1 }}
                        >
                            {t`Показать только парковки без самокатов`}
                        </label>
                        <label className={styles.switch}>
                            <input
                                type='checkbox'
                                id='rebalanceOnlyEmpty'
                                checked={rebalanceOnlyEmptyEnabled}
                                onChange={onChangeRebalanceOnlyEmptyEnabled}
                            />
                            <span className={classnames(styles.sliderRound, styles.slider)} />
                        </label>
                    </div>
                </div>
            )}
            {/* DA-14493: тогглы мин. порога (избыток / дефицит) — только в режиме «Таба» */}
            {!isForecast && (
                <div style={{ paddingLeft: '0px', display: 'flex', flexDirection: 'column', gap: '2px', marginBottom: '10px' }}>
                    {MIN_GAP_TOGGLES.map(({ id, label, checked, onChange }) => (
                        <div
                            key={id}
                            className={styles.isochroneFilterLabel}
                        >
                            <span style={{ width: '26px', flexShrink: 0 }} />
                            <label
                                htmlFor={id}
                                style={{ flex: 1 }}
                            >
                                {label}
                            </label>
                            <label className={styles.switch}>
                                <input
                                    type='checkbox'
                                    id={id}
                                    checked={checked}
                                    onChange={onChange}
                                />
                                <span className={classnames(styles.sliderRound, styles.slider)} />
                            </label>
                        </div>
                    ))}
                    <span
                        style={{ paddingLeft: '34px' }}
                        className={styles.legendTextBlock}
                    >
                        {t`Параметр из настроек Региона`}
                    </span>
                </div>
            )}
            {isForecast ? (
                <>
                    <LegendRenderer config={REBALANCE_FORECAST_SIZE_LEGEND} />
                    <LegendRenderer config={REBALANCE_FORECAST_LEGEND} />
                </>
            ) : (
                <>
                    <LegendRenderer config={REBALANCE_DELTA_SIZE_LEGEND} />
                    <LegendRenderer config={REBALANCE_DELTA_LEGEND} />
                </>
            )}
        </div>
    );
};
const mapStateToProps = ({ mapFilters: {
    rebalanceForecastTabaMode, rebalanceMinGapUpEnabled, rebalanceMinGapDownEnabled, rebalanceOnlyEmptyEnabled,
} }) => ({
    rebalanceForecastTabaMode,
    rebalanceMinGapUpEnabled,
    rebalanceMinGapDownEnabled,
    rebalanceOnlyEmptyEnabled,
});
const ConnectedComponent = connect(mapStateToProps, {
    onChangeMapFilters,
    onChangeRebalanceMinGapUpEnabled,
    onChangeRebalanceMinGapDownEnabled,
    onChangeRebalanceOnlyEmptyEnabled,
})(RebalanceForecastTabaLegendComponent);
export const RebalanceForecastTabaLegend = withDisplayedLayersCheck(ConnectedComponent, t`Таба/Форкаст`);
